<template>
  <div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-12">
        <!-- BEGIN: Bordered Table -->
        <div class="intro-y box mt-5">
          <div
            v-if="$h.isset(this.$store.state.auth.user)"
            class="flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
          >
            <h2
              v-if="$store.state.auth.user.isAdmin == 0"
              class="font-medium text-base mr-auto"
            >
              {{ this.$store.state.auth.user.agencyName }}
            </h2>
            <select
              v-if="$store.state.auth.user.isAdmin >= 1"
              v-model="agencyId"
              type="text"
              class="input input--lg border w-full lg:w-auto mt-3 lg:mt-0 mr-auto"
              @change="onChangeDay()"
            >
              <option value="">전체</option>
              <option
                v-for="(agency, index) in agencies"
                :key="index"
                :value="agency.id"
              >
                <h2 class="font-medium text-base mr-auto">
                  {{ agency.name }}
                </h2>
              </option>
            </select>
            <button
              v-if="isQuickRangeAllowed(7)"
              class="button nline-block w-full lg:w-24 mt-3 lg:mt-0 lg:ml-5 lg:mr-1 border border-theme-1 text-theme-1 dark:border-theme-10 dark:text-theme-10"
              @click="calcOneWeek()"
            >
              1주일
            </button>
            <button
              v-if="isQuickRangeAllowed(30)"
              class="button inline-block w-full lg:w-24 mt-3 lg:mt-0 lg:mr-1 border border-theme-9 text-theme-9 dark:border-theme-9"
              @click="calcOneMonth()"
            >
              1개월
            </button>
            <button
              v-if="isQuickRangeAllowed(92)"
              class="button inline-block w-full lg:w-24 mt-3 lg:mt-0 lg:mr-1 border border-theme-12 text-theme-12 dark:border-theme-12"
              @click="calcThreeMonth()"
            >
              3개월
            </button>
            <button
              v-if="isQuickRangeAllowed(184)"
              class="button inline-block w-full lg:w-24 mt-3 lg:mt-0 lg:mr-5 border border-theme-6 text-theme-6 dark:border-theme-6"
              @click="calcSixMonth()"
            >
              6개월
            </button>
            <div class="w-full flex items-center justify-between">
              <el-date-picker
                v-model="listQuery.dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="~"
                start-placeholder="시작날짜"
                end-placeholder="마지막날짜"
                value-format="yyyy-MM-dd"
                :picker-options="deletedPeriodPickerOptions"
                @change="onChangeDay"
              >
              </el-date-picker>
              <div class="flex items-center lg:ml-auto mt-3 lg:mt-3">
                <button
                  class="button w-24 mr-1 mb-2 bg-theme-12 text-white"
                  @click="exportExcel()"
                >
                  엑셀출력
                </button>
              </div>
            </div>
          </div>
          <div id="bordered-table" class="p-5">
            <div class="preview">
              <div class="overflow-x-auto">
                <table class="table">
                  <thead>
                    <tr>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        기간
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        미국
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        일본
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        중국
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        유럽연합
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        영국
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        싱가포르
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        캐나다
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        필리핀
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        대만
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        홍콩
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        태국
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        호주
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        뉴질랜드
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        말레이시아
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        러시아
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        스위스
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        베트남
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        기타
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(statistic, index) in statistics" :key="index">
                      <td class="border dark:border-dark-5 text-center">
                        {{ statistic.day }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.USD_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.JPY_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.CNY_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.EUR_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.GBP_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.SGD_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.CAD_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.PHP_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.TWD_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.HKD_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.THB_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.AUD_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.NZD_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.MYR_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.RUB_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.CHF_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.VND_W) }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        ₩{{ $h.filterCurrency(statistic.OTH_W) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="border dark:border-dark-5 text-center">
                        합계
                      </td>
                      <td
                        v-for="(totalSum, index) in totalSums"
                        :key="index"
                        class="border dark:border-dark-5 text-center"
                      >
                        {{
                          $h.filterCurrency(totalSum[0]) +
                            $h.filterCurrency(totalSum[1])
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="border dark:border-dark-5 text-center">
                        총수익
                      </td>
                      <td
                        class="border dark:border-dark-5 text-center"
                        colspan="18"
                      >
                        ₩ {{ $h.filterCurrency(totalAmount) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Bordered Table -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { export_json_to_excel } from "@/assets/js/vendor/Export2Excel";

export default {
  data() {
    return {
      agencyId: "",
      agencies: [],
      statistics: [],
      totalSums: [],
      totalAmount: 0,
      startDay: "",
      endDay: "",
      listQuery: {
        dateRange: ["", ""]
      }
    };
  },
  async mounted() {
    await this.tokenLogin();
    await this.getAgencies();
    let date = new Date();
    this.startDay = moment(date).format("YYYY-MM-DD");
    this.listQuery.dateRange = [this.startDay, this.startDay];
    this.getStatistic();
  },
  methods: {
    async tokenLogin() {
      // console.log("tokenLogin");
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios
        .post(this.$api().tokenLogin, data)
        .then(res => {
          resultData = res.data;
          // console.log(resultData);
        })
        .catch(err => {
          console.dir(err);
        });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
      async getAgencies() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios
        .post(this.$api().getAgencies, data)
        .then(res => {
          let resultData = this.$h.assign(res.data);
          this.agencies = resultData.data;
        });
    },
    calcOneWeek() {
      let date = new Date();
      this.endDay = moment(date).format("YYYY-MM-DD");
      let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
      this.startDay = moment(startDate).format("YYYY-MM-DD");
      this.listQuery.dateRange = [this.startDay, this.endDay];
      this.getStatistic();
    },
    calcOneMonth() {
      let date = new Date();
      this.endDay = moment(date).format("YYYY-MM-DD");
      let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 30);
      this.startDay = moment(startDate).format("YYYY-MM-DD");
      this.listQuery.dateRange = [this.startDay, this.endDay];
      this.getStatistic();
    },
    calcThreeMonth() {
      let date = new Date();
      this.endDay = moment(date).format("YYYY-MM-DD");
      let startDate = new Date(
        date.getTime() - 3600 * 1000 * 24 * 30 * 3 - 3600 * 1000 * 24 * 2
      );
      this.startDay = moment(startDate).format("YYYY-MM-DD");
      this.listQuery.dateRange = [this.startDay, this.endDay];
      this.getStatistic();
    },
    calcSixMonth() {
      let date = new Date();
      this.endDay = moment(date).format("YYYY-MM-DD");
      let startDate = new Date(
        date.getTime() - 3600 * 1000 * 24 * 30 * 6 - 3600 * 1000 * 24 * 4
      );
      this.startDay = moment(startDate).format("YYYY-MM-DD");
      this.listQuery.dateRange = [this.startDay, this.endDay];
      this.getStatistic();
    },
    onChangeDay() {
      this.getStatistic();
    },
    async getStatistic() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        startDay: this.listQuery.dateRange[0],
        endDay: this.listQuery.dateRange[1],
        agencyId: this.agencyId
      };
      await axios
        .post(this.$api().getStatistic, data)
        .then(res => {
          let resultData = this.$h.assign(res.data);
          this.statistics = resultData.data;
          //console.log("totalSums : ", resultData.totalSums);
          this.totalSums = resultData.totalSums;
          this.totalAmount = resultData.totalAmount;
        })
        .catch(err => {
          console.dir(err);
        });
    },
    exportExcel() {
      let th = [
        "기간",
        "미국",
        "일본",
        "중국",
        "유럽연합",
        "영국",
        "싱가포르",
        "캐나다",
        "필리핀",
        "대만",
        "홍콩",
        "태국",
        "호주",
        "뉴질랜드",
        "말레이시아",
        "러시아",
        "스위스",
        "베트남",
        "기타"
      ];
      let jsonData = [];
      {
        for (let i = 0; i < this.statistics.length; i++) {
          let row = [];
          row.push(this.statistics[i].day);
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].USD_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].JPY_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].CNY_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].EUR_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].GBP_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].SGD_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].CAD_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].PHP_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].TWD_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].HKD_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].THB_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].AUD_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].NZD_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].MYR_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].RUB_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].CHF_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].VND_W));
          row.push("₩" + this.$h.filterCurrency(this.statistics[i].OTH_W));
          jsonData.push(row);
        }
      }
      {
        let row = [];
        row.push("합계");
        for (let i = 0; i < this.totalSums.length; i++) {
          row.push(
            this.$h.filterCurrency(this.totalSums[i][0]) +
              this.$h.filterCurrency(this.totalSums[i][1])
          );
        }
        jsonData.push(row);
      }
      {
        let row = [];
        row.push("총수익");
        row.push("₩" + this.$h.filterCurrency(this.totalAmount));
        jsonData.push(row);
      }
      export_json_to_excel(th, jsonData, "tablePrint");
    }
  }
};
</script>
